import React from 'react'
import './newsthrought.scss'
import { images } from "../../../utils/customFn";
import { Link, NavLink } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
const NewsThrought = () => {

  const mediaTeam = [
    {
      image: images["leader1.avif"],
      name: "Carolyn Schamberger",
      office: "715-346-7104",
      mobile: "715-315-9929",
      email: "carolyn.schamberger@sentry.com",
    },
    {
      image: images["leader2.avif"],
      name: "Avery Faehling",
      office: "715-346-7354",
      mobile: "715-697-4590",
      email: "avery.faehling@sentry.com",
    },
    {
      image: images["leader3.avif"],
      name: "Rick LaFrombois",
      office: "715-346-8239",
      mobile: "715-581-9396",
      email: "rick.lafrombois@sentry.com",
    },
    {
      image: images["leader4.avif"],
      name: "Hannah Quick",
      office: "715-346-7403",
      mobile: "715-323-9174",
      email: "hannah.quick@sentry.com",
    },

  ];

  return (
    <>
      <div className='left-media-team'>
        <div className='top-heading-note'>
          <p>We want to keep you informed and engaged with all things Sentry. Here, you'll find our latest news releases, thought leadership insights, and information on who to contact with questions or help with developing your story.</p>
          <p>For media inquiries, please contact:</p>
        </div>
        {mediaTeam.map((member, index) => (
          <Row key={index} className="media-row">
            <Col sm={12} md={12} lg={4} xl={4} className='ps-0'>
              <div className="media-image">
                <img src={member.image} alt={member.name} />
              </div>
            </Col>
            <Col sm={12} md={12} lg={8} xl={8}>
              <div className="personal-details-common">
                <p>{member.name}</p>
                <p>Office: {member.office}</p>
                <p>Mobile: {member.mobile}</p>
                <NavLink to={`mailto:${member.email}`}>{member.email}</NavLink>
              </div>
            </Col>
          </Row>
        ))}
      </div>
    </>
  )
}

export default NewsThrought